import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useFetchData } from "../../../helpers/GlobalHelper";

const LmsServicingAutoPoRestrictions = () => {
  const [{ fetchData }] = useFetchData();
  const handleClick = async ({ inputs, setInputs, setFormErrorMessage }) => {
    const loanId = inputs.loanId;
    if (loanId) {
      const newInputs = { ...inputs, writingResults: "Loading...", isResultHidden: false };
      setInputs(newInputs);
      const { data: resData, error: resError } = await fetchData(
        `payoffquotes/under-writing-details/${loanId}`
      );

      if (resError) {
        setFormErrorMessage(resError);
        return;
      }

      setInputs({
        ...newInputs,
        writingResults: Object.keys(resData)
          .map((key) => `${key.toUpperCase()}: ${resData[key]}`)
          .join(", "),
      });
    } else {
      setFormErrorMessage({
        message: "Please select a Loan.",
      });
    }
  };

  const myForm = new BCFormController(
    {},
    {
      submitSuffix: "payoffquotes/check-payoff-restrictions",
      values: { isResultHidden: true },
      onSubmitSuccess: (response, options) => {
        options.setInputs({ ...options.inputs, listResponseData: response.split("</br>") });
      },
    }
  );

  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan", "loans/list-loans", {
      name: "loanId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup(
    [myForm.getDisplayField("Result: ", { label: "", name: "writingResults" })],
    { isHidden: { isResultHidden: true } }
  );

  myForm.addCenteredGroup([
    myForm.getButtonField("Underwriting Details", handleClick, {
      fullWidth: true,
    }),
  ]);
  myForm.addCenteredGroup([
    myForm.getDropdownField(
      "Loan Property Unit Reconveyance",
      "loans/{id}/list-loan-property-unitreconveyace",
      {
        name: "Loan_Property_UnitReconveyanceId",
        dependencyField: "loanId",
      }
    ),
  ]);

  myForm.addCenteredGroup([myForm.getCalendarField("Valid Through Date", { required: true })]);
  myForm.addCenteredGroup([
    myForm.getListField("listResponseData", { listOptions: [], listItemType: "Text" }),
  ]);

  return (
    <LmsFormGenerator myForm={myForm} actions={[{ action: "save", text: "Submit" }, "close"]} />
  );
};

export default LmsServicingAutoPoRestrictions;
